module.exports = __webpack_public_path__ + "img/image3.3812f3ee.jpg";